import React, { useEffect, useState, useRef } from 'react';
import { addCommentToRequest, getDentalRequests, getDentalRequestComments, getProcedures, addProcedureRequest, deductWalletBalance, callPatient, markProcedureRemoved, uploadPrescription, refundProcedureAmount, resendCashlessLetter } from '../../../services/api/cashless-dentals';
import { callCustomRequest } from '../../../services/api/offline-consult';
import AppointmentTimeline from '../components/AppointmentTimeline';
import CommsLog from '../components/CommsLog';
import UpdateAppointmentDateModal from './UpdateAppointmentDateModal';
import RequestRow from '../../cashless-vaccination/modals/RequestRow';
import { Button, ButtonGroup, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
import Select from 'react-select';
import styled from 'styled-components';
import { BoldText, RegularText, Text } from '../../common/Text';
import CommentList from '../../offline-consultations/comments/commentList';
import CommentForm from '../../cashless-vaccination/components/CommentForm';
import { toast } from 'react-toastify';
import { FaArrowAltCircleUp, FaPhone, FaSpinner } from 'react-icons/fa';
import ConfirmationModal from '../../common/ConfirmationModal';
import Fuse from 'fuse.js';
import StyledTappable from '../../common/StyledTappable';
import LoadingComponent from '../../common/LoadingComponent';
import { useSelector } from 'react-redux';
import { dentalVaccinationOpsUserId } from '../../cashless-vaccination/styled-elements';
import { getBlobUrl } from '../../../utils/getBlobUrlAndContentType';

/**
 * Generates a Google Maps location URL using latitude and longitude.
 *
 * @param {number} latitude - Latitude of the location
 * @param {number} longitude - Longitude of the location
 * @returns {string} Google Maps URL
 */
 function getGoogleMapsLink(latitude, longitude) {
  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    throw new TypeError('latitude and longitude must be numbers');
  }
  return `https://www.google.com/maps?q=${latitude},${longitude}`;
}


const DetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
`;

const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;


const UploadPrescriptionButton = styled(StyledTappable)`
  /* width: 14rem;
  height: 2rem;
  padding: 1.2rem;
  margin-left: 0.625rem;
  margin-top: 0.625rem;
  border: 1px solid #8852cc;
  border-radius: 0.2rem; */
  justify-content: flex-start;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
`;

const UploadText = styled(BoldText)`
  font-size: 1.2rem;
  margin-left: 0.625rem;
  color: #8852cc;
  text-align: left;
`;

const SectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.625rem;
  width: 100%;
`;

const SectionHeader = styled(BoldText)`
  font-size: 1.2rem;
  color: #4b4f5b;

`;

const SectionBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 0.625rem;
  word-wrap: break-word;
`;

const SpocDetailContainer = styled(SectionContainer)`
  background-color: #f8f9fa;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  padding: 0.625rem;
  width: 100%;
`;

const DialogBox = styled.div`
    border: 1px solid #007bff;
    background-color: #FFFFFF;
    padding: 10px;
    color: white;
    border-radius: 10px;
    width: 100%;
`
const buttonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    width: 100%;
`
const approveButton = styled.div`
    border: 2px solid green;
    background-color: #FFFFFF;
    width: 100%;
`
const CallUserText = styled(BoldText)`
  font-size: 1rem;
  margin-left: 0.4rem;
  color: #56c02c;
  cursor: pointer;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 0.25rem;
`;

const DetailName = styled(Text)`
  font-size: 1rem;
  width: ${props => (props.fullWidth ? '20rem' : '8rem')};
  color: #4c4c4c;
`;

const DetailTextDanger = styled(RegularText)`
  font-size: 1rem;
  color: #ff4d48;
`;

const ProcedureTableCell = styled.td`
  border: none;
  color: ${props => (props.completed ? 'inherit' : '#999')};
`;
// format procedure completed at timestamp 
const formatCompletedAt = (value) =>
  value
    ? new Date(value).toLocaleString('en-IN', {
        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
      })
    : 'Not completed yet';


const CommentsPanel = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  background-color: #ffffff;
  overflow: hidden;
`;

const CommentsPanelHeader = styled.div`
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e4e6ef;
  font-size: 1rem;
  font-weight: 600;
  color: #4b4f5b;
`;

const CommentsScrollArea = styled.div`
  position: relative;
  max-height: 260px;
  overflow-y: auto;
  padding: 0 0.75rem;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b9bdcc;
    border: 2px solid #f2f3f7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #9aa0b3;
  }
  &::-webkit-scrollbar-track {
    background-color: #f2f3f7;
  }

  /* the list's own heading duplicates the panel header */
  .commentList > h5 {
    display: none;
  }

  /* shared Comment markup: tighten it so more history fits in the cap */
  .media {
    margin-bottom: 0.5rem;
  }
  .media:first-child {
    margin-top: 0.75rem;
  }
  .media-body {
    font-size: 0.9rem;
  }
  .media-body h6 {
    font-size: 0.85rem;
  }
`;

const CommentsFade = styled.div`
  height: 1rem;
  margin-top: -1rem;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
`;

const CommentsComposer = styled.div`
  padding: 0.75rem;
  border-top: 1px solid #e4e6ef;
  background-color: #fbfbfd;
`;

// approval timestamp, shown only once the user has approved the procedure
const formatApprovedAt = (value) =>
  value
    ? new Date(value).toLocaleString('en-IN', {
        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
      })
    : '';

const APPROVAL_STATUS_COLORS = {
  approved: '#0B7A55',
  'pending-approval': '#B26A00',
  refunded: '#ff4d48',
};

const ApprovalHeaderCell = styled.th`
  border: none;
  white-space: nowrap;
`;

const ApprovalCell = styled.td`
  border: none;
  white-space: nowrap;
`;

const ApprovalStatusText = styled.div`
  color: ${props => props.tone || 'inherit'};
`;

const ApprovalMetaText = styled.div`
  font-size: 0.85rem;
  color: ${props => props.tone || '#666'};
`;

const POLICY_COVERAGE_COLORS = {
  covered: '#0B7A55',
  'not-covered': '#ff4d48',
  'not-evaluated': '#999',
};

// short forms of policyCoverageLabel, so the cell stays one line in the narrow modal
const POLICY_COVERAGE_SHORT = {
  covered: 'Covered in policy',
  'not-covered': 'Not covered in policy',
  'not-evaluated': 'Coverage unknown',
};

const AgreedCostCell = styled.td`
  border: none;
  white-space: nowrap;
`;

const AgreedCostMissing = styled.div`
  font-size: 0.85rem;
  color: #B26A00;
`;

const AgreedCostMismatch = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #ff4d48;
  /* the cell itself is nowrap for the price; let the longer sentence wrap */
  white-space: normal;
  max-width: 9rem;
`;

// The city tier is a property of the clinic, so every procedure on a request
// carries the same one — read it off the first row that has it.
const resolveClinicTier = (procedures) =>
  (procedures || []).find(procedure => procedure.clinicTier)?.clinicTier || null;

// Only MDP bills us against a contracted tier price, so the whole column is
// hidden for anyone else. service_provider comes straight off the request row,
// which settles what the isMdpRequest heuristic below only approximates.
const hasAgreedCostColumn = (procedures) =>
  (procedures || []).some(procedure => procedure.serviceProvider === 'mdp');

// MDP quotes a fee per procedure; we separately contract a price per city tier.
// Any gap between the two is a reconciliation item for Finance, so it is spelled
// out with its direction rather than left as a signed number to decode. A missing
// agreed cost is spelled out too, because each cause needs a different fix.
const renderAgreedCost = (procedure) => {
  if (!procedure.clinicTier) {
    return <AgreedCostMissing>Tier not synced</AgreedCostMissing>;
  }
  if (procedure.agreedCost === null || procedure.agreedCost === undefined) {
    return <AgreedCostMissing>Not in price list</AgreedCostMissing>;
  }

  const agreedCost = Number(procedure.agreedCost);
  const delta = Number(procedure.cost) - agreedCost;
  return (
    <>
      <div>₹{agreedCost}</div>
      {delta !== 0 ? (
        <AgreedCostMismatch>
          MDP billed ₹{Math.abs(delta)} {delta > 0 ? 'more' : 'less'}
        </AgreedCostMismatch>
      ) : ''}
    </>
  );
};

const DentalRequestDetails = ({
    details, onClose, isOpen, key
}) => {
    const imageAttachmentRef = useRef(null);
    const [ dentalInfo, setDentalInfo ] = useState({});
    const [ basicInfo, setBasicInfo ] = useState({});
    const [ newCenterDetails, newCenterDetailsInfo ] = useState({});
    const [ policyDetails, setPolicyDetails ] = useState({});
    const [activeInfo, setActiveInfo] = useState('basic');
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [procedureDetails, setProcedureDetails] = useState(null);
    const [procedureAmount, setProcedureAmount] = useState('');
    const [comments, setComments] = useState([]);
    const [showProcedureDialog, setShowProcedureDialog] = useState([]);
    const [procedureList, setProcedureList] = useState([]);
    const [procedureAddRequestId, setProcedureAddRequestId] = useState(null);
    const [callPatientLoading, setCallPatientLoading] = useState(false);
    const [callSpocLoading, setCallSpocLoading] = useState(false);
    const [callTarget, setCallTarget] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [procedureNotCovered, setProcedureNotCovered] = useState('');
    const [removeApproveButton, setRemoveApproveButton] = useState(false);
    const [deletePastProcedure, setDeletePastProcedure] = useState(null);
    const [deletePastProcedureAmount, setDeletePastProcedureAmount] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [resendLetterLoading, setResendLetterLoading] = useState(false);
    const [showEditDateModal, setShowEditDateModal] = useState(false);

    const opsUserId = dentalVaccinationOpsUserId
    const user = useSelector((state) => state.user.userId)
    console.log(user, '[user]');
    // MDP requests should not allow ops to add procedures.
    // MDP is signaled either by a positive mdpAppointmentId (canonical reschedule signal,
    // threaded in via the row) or by the absence of a partnerName on the fetched record
    // (the table's own MDP heuristic — see DentalTable.js).
    const isMdpRequest =
      Number(details?.mdpAppointmentId) > 0 ||
      Number(basicInfo?.mdpAppointmentId) > 0 ||
      (Object.keys(basicInfo || {}).length > 0 && !basicInfo?.partnerName);
    // Both are properties of the request, not of a row — resolve once rather than
    // re-scanning the procedure list for every row rendered.
    const clinicTier = resolveClinicTier(showProcedureDialog);
    const showAgreedCost = hasAgreedCostColumn(showProcedureDialog);
    const agreedCostHeading = clinicTier ? `Agreed (${clinicTier})` : 'Agreed';
    const hasProcedureDetails = procedureDetails && procedureDetails.length > 0;
    const allProceduresApproved = procedureDetails && procedureDetails.length > 0 && procedureDetails.every(detail => detail.success === 1);
    
    const handleComments = response => {
      console.log(response,'[responsecomment]')
      const comments = [];
      if (Array.isArray(response) && response.length) {
        response.forEach(c => {
          comments.push({
            name: c.userName,
            message: c.comment,
            time: c.createdAt,
          });
        });
      }
      console.log(comments,'[returnCOmment]')
      return comments;
    };

    const findRequestInformation = (requestId) => {
      setLoading(true);
        getDentalRequests(requestId)
            .then((res) => {
              console.log('[basicInfo]', res)
                setBasicInfo(res)
                setPolicyDetails(res.policyDetails);
                 newCenterDetailsInfo({
                centerLocation: res.centerLocation,
                clinicAddress: res.clinicAddress,
                doctorName: res.doctorName,
                doctorEmail: res.doctorEmail,
                spocName: res.spocName,
                spocEmail: res.spocEmail,
                spocPhone: res.spocPhone,
              })
                if (res.procedureRequests.length) {
                  setShowProcedureDialog(res.procedureRequests)
                }
            }).then(()=>{
              return getDentalRequestComments(requestId)
            }).then((res)=>{
              const commentData = handleComments(res)
              setComments(commentData)
            })
            .then(() => {
              return getProcedures(requestId); 
            })
            .then((procedureData) => {
              console.log(procedureData,'[procedureData]')
              if (Array.isArray(procedureData) && procedureData.length === 1) {
                setProcedureDetails({value:procedureData[0].procedureId, label:procedureData[0].displayName});
                setProcedureAmount(Number(procedureData[0].procedureCost))
                setDeletePastProcedure({value:procedureData[0].procedureId, label:procedureData[0].displayName});
                setDeletePastProcedureAmount(Number(procedureData[0].procedureCost))
                setProcedureAddRequestId(procedureData[0].procedureRequestId)
                setRemoveApproveButton(true);
              }
              const transformedData = (procedureData || []).map((item) => ({
                value: item.procedureId,
                label: item.displayName
              }));
              setProcedureList(transformedData)
              setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
            })
    };
    const handleAddProcedureDetails = () => {
        setShowDialog(true);
    };
    const handleCancel = () => {
        setShowDialog(false);
        setRemoveApproveButton(false);
        setProcedureNotCovered('');
        setProcedureAmount('');
        setProcedureDetails(null);
    };

    useEffect(() => {
        if (details.requestId) {
            setShowProcedureDialog([])
            setComments([])
            setProcedureList([])
            findRequestInformation(details.requestId)
        }
    }, [details]);

    const addComment = (comments) => {
      console.log(comments, '[comment]')
        // const { requestId } = props;
        setComments(comments)
    }

    const initiateCall = (type) => {
      console.log('[inside initiate call]', type);
      switch (type) {
        case 'PATIENT': {
          const { patientPhone, userPhone } = basicInfo;
          console.log({ patientPhone, userPhone }, '[patientPhone]');
          if (patientPhone || userPhone) {
            setCallPatientLoading(true);
            setCallTarget('PATIENT');
            setConfirmationMessage(`Are you sure you want to call ${patientPhone ? patientPhone : userPhone}?`);
            setShowConfirmationModal(true);
          }
          break;
        }
        case 'SPOC': {
          const spocPhone = newCenterDetails?.spocPhone;
          if (!spocPhone) {
            return;
          }
          setCallSpocLoading(true);
          setCallTarget('SPOC');
          setConfirmationMessage(`Are you sure you want to call ${spocPhone}?`);
          setShowConfirmationModal(true);
          break;
        }
        default:
          break;
      }
    };

    const openAttachment = () => {
      if (imageAttachmentRef.current) {
          imageAttachmentRef.current.click();
      }
    };

    const handleFileChange = (event) => {
      if (event.target.files && event.target.files.length > 0) {
          const selectedFile = event.target.files[0];
          console.log('Selected file:', selectedFile);
          if (selectedFile) {
            setUploading(true);
            const { requestId, userId } = basicInfo;
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('userId', userId);
            formData.append('requestId', requestId);
            formData.append('preview', selectedFile);
            uploadPrescription(formData)
            .then((response)=> {
              if(response.message === 'success') {
                toast.success('File Uploaded Successfully')
                setUploading(false);
                findRequestInformation(requestId);
              }
            }).catch((err)=> {
              console.error({err}, '[err]');
            })
          } else {
            toast.message('File Not Selected')
          }
          
          
      }
  };

    const handleResendCashlessLetter = async () => {
      const { requestId } = basicInfo;
      setResendLetterLoading(true);
      try {
        await resendCashlessLetter(requestId);
        // resolved means 200
        toast.success('Cashless letter resent successfully');
      } catch (err) {
        console.error(err, '[handleResendCashlessLetter]');
        const status = err?.response?.status;
        if (status === 400) {
          toast.error(err?.response?.data?.message || 'Bad request. Please check the details.');
        } else if (status === 500) {
          toast.error('Internal server error. Please try again later.');
        } else {
          toast.error('Failed to resend cashless letter');
        }
      } finally {
        setResendLetterLoading(false);
      }
    };

    // Resend is allowed once the request has moved past intake, regardless of whether a letter exists yet
    const canResendCashlessLetter =
      Boolean(basicInfo?.requestStatus) &&
      !['pending', 'cancelled'].includes(basicInfo.requestStatus);

    const renderBasicInfo = () => (
        <DetailsContainer>
            <SectionContainer>
                <SectionInnerContainer>
                    <SectionHeader>User Booking Details</SectionHeader>
                    <SectionBody>
                        <RequestRow name='User Id:' value={basicInfo.userId} />
                        <DetailRow>
                          <DetailName>Appoint. Date:</DetailName>
                          <span>{basicInfo.appointmentDate}</span>
                          <Button
                            size="sm"
                            color="primary"
                            outline
                            style={{ marginLeft: '8px', padding: '2px 10px', fontSize: '0.8rem' }}
                            onClick={() => setShowEditDateModal(true)}
                          >
                            Edit
                          </Button>
                        </DetailRow>
                        <RequestRow name='Appoint. Slot:' value={basicInfo.appointmentTime} />
                        <RequestRow name='Request Date' value={basicInfo.appointmentCreatedAt} />
                        <RequestRow name='Request Time' value={basicInfo.appointmentCreatedTime} />
                        <RequestRow name='Patient Name:' value={basicInfo.patientName} />
                        <RequestRow name='Patient Relation:' value={basicInfo.patientRelation} />
                        <RequestRow name='Patient DOB:' value={basicInfo.patientDob} />
                        <DetailRow>
                          <DetailName>Patient Phone:</DetailName> 
                          {basicInfo.patientPhone ? (
                            <CallUserText onClick={() => initiateCall('PATIENT')}>
                              {callPatientLoading ? (
                                <FaSpinner
                                  size={15}
                                  style={{ paddingBottom: 2 }}
                                  className="icon-spin text-success"
                                />
                              ) : (
                                <FaPhone
                                  size={15}
                                  style={{ paddingBottom: 2 }}
                                  className="text-success"
                                />
                              )}
                              {'  '}
                              {basicInfo.patientPhone}
                            </CallUserText>
                          ) : (
                            <DetailTextDanger>Unavailable</DetailTextDanger>
                          )}
                         </DetailRow>
                        <RequestRow name='User Email:' value={basicInfo.userEmail} />
                        <DetailRow>
                          <DetailName>User Phone:</DetailName> 
                          {basicInfo.userPhone ? (
                            <CallUserText onClick={() => initiateCall('PATIENT')}>
                              {callPatientLoading ? (
                                <FaSpinner
                                  size={15}
                                  style={{ paddingBottom: 2 }}
                                  className="icon-spin text-success"
                                />
                              ) : (
                                <FaPhone
                                  size={15}
                                  style={{ paddingBottom: 2 }}
                                  className="text-success"
                                />
                              )}
                              {'  '}
                              {basicInfo.userPhone}
                            </CallUserText>
                          ) : (
                            <DetailTextDanger>Unavailable</DetailTextDanger>
                          )}
                         </DetailRow>
                        <RequestRow name='Request Status'  value={basicInfo.requestStatus} />
                        <RequestRow name='Prescription Status'  value={basicInfo.prescriptionStatus} />
                    </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
            <SectionContainer>
              <SectionInnerContainer>
                <SectionBody>
                    <DetailRow>
                          <DetailName>Cashless letter:</DetailName>
                          {basicInfo.cashlessLetter ? (
                             // eslint-disable-next-line jsx-a11y/anchor-is-valid
                             <a onClick={async () => {
                              basicInfo.cashlessLetter = await getBlobUrl(basicInfo.cashlessLetter);
                              window.open(basicInfo.cashlessLetter, '_blank');
                            }}
                            style={{color:'blue'}}
                             >View</a>
                          ) : (
                            <DetailTextDanger>Unavailable</DetailTextDanger>
                          )}
                          {canResendCashlessLetter ? (
                             <Button
                               size="sm"
                               color="warning"
                               style={{ marginLeft: '0.75rem' }}
                               onClick={handleResendCashlessLetter}
                               disabled={resendLetterLoading}
                             >
                               {resendLetterLoading ? 'Sending...' : 'Resend Cashless Letter'}
                             </Button>
                          ) : null}
                         </DetailRow>
                    <DetailRow>
                          <DetailName>Prescription Link:</DetailName> 
                          {basicInfo.prescriptionUrl ? (
                             // eslint-disable-next-line jsx-a11y/anchor-is-valid
                             <a onClick={async () => {
                              basicInfo.prescriptionUrl = await getBlobUrl(basicInfo.prescriptionUrl);
                              window.open(basicInfo.prescriptionUrl, '_blank');
                            }}
                            style={{color:'blue'}}
                             >View</a>
                          ) : (
                            <DetailTextDanger>Unavailable</DetailTextDanger>
                          )}
                         </DetailRow>
                         <DetailRow>
                          <Button
                            onClick={() => {
                              navigator.clipboard.writeText(`
Doctor name : ${basicInfo.doctorName}
Patient name : ${basicInfo.patientName}
Patient phone : ${basicInfo.patientPhone}
Center name : ${basicInfo.centerLocation}
Center address : ${basicInfo.clinicAddress}
Appointment date : ${basicInfo.appointmentDate}
                              `
                              );
                            }}
                          >
                            Copy Details
                          </Button>
                          {(basicInfo?.requestStatus !== 'completed' && basicInfo?.requestStatus !== 'cancelled' && basicInfo?.prescriptionStatus !== 'uploaded' && basicInfo?.requestStatus !== 'pre-auth-requested'  ) ? <div> <UploadPrescriptionButton 
                            onTap={openAttachment}
                          >
                            {uploading ?  <LoadingComponent/> : <UploadText>Upload Prescription</UploadText>}
                        </UploadPrescriptionButton>
                        <input
                            type="file"
                            id="imageAttachment"
                            ref={imageAttachmentRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        </div> : ''}
                         </DetailRow>
                </SectionBody>
                </SectionInnerContainer>
            </SectionContainer>
        </DetailsContainer>
    )
    
    const renderCenterInfo = () => (
      <DetailsContainer>
          <SectionContainer>
              <SectionInnerContainer>
                  <SectionHeader>Center Details:</SectionHeader>
                  <SectionBody>
                      <RequestRow name='Doctor Name:' value={basicInfo.doctorName} />
                      <RequestRow name='Center:' value={basicInfo.centerLocation} />
                      {/* MDP requests are not tied to a network center, so there is no id to show */}
                      {basicInfo.centerId ? (
                        <RequestRow name='Center Id:' value={basicInfo.centerId} />
                      ) : null}
                      <RequestRow name='Center Address:' value={basicInfo.clinicAddress} />
                      <RequestRow name='Pincode:' value={basicInfo.centerPincode} />
                      <RequestRow name='City:' value={basicInfo.centerCity} />
                      <RequestRow name='District:' value={basicInfo.centerDistrict} />
                      <RequestRow name='State:' value={basicInfo.centerState} />
                      <DetailRow>
                      <DetailName>Clinic Location:</DetailName>
                      {basicInfo.clinicLocation ? (
                        <a onClick={() =>
                          window.open(`${basicInfo.clinicLocation}`)
                        } style={{color:'blue'}}>Go to Location</a>
                      ): (
                        <DetailTextDanger>Unavailable</DetailTextDanger>
                      )}
                    </DetailRow>
                  </SectionBody>
              </SectionInnerContainer>
          </SectionContainer>
          <SectionContainer>
            <SectionInnerContainer>
              <SectionHeader>Spoc Details</SectionHeader>
              <SectionBody>
                      <RequestRow name='Name:' value={newCenterDetails?.spocName} />
                      <RequestRow name='Email:' value={newCenterDetails?.spocEmail} />
                      <DetailRow>
                        <DetailName>Phone Number:</DetailName>
                        {newCenterDetails?.spocPhone ? (
                          <CallUserText onClick={() => initiateCall('SPOC')}>
                            {callSpocLoading ? (
                              <FaSpinner
                                size={15}
                                className="icon-spin text-success"
                              />
                            ) : (
                              <FaPhone
                                size={15}
                                className="text-success"
                              />
                            )}
                            {'  '}
                            {newCenterDetails?.spocPhone}
                          </CallUserText>
                        ) : (
                          <DetailTextDanger>Unavailable</DetailTextDanger>
                        )}
                      </DetailRow>
                  </SectionBody>
            </SectionInnerContainer>
          </SectionContainer>
      </DetailsContainer>
  )

    const addProcedureRequests = () => {
      const { requestId } = details;
      console.log({procedureDetails, procedureAmount, requestId}, '[procedureDetails][data]')
        addProcedureRequest(requestId, procedureDetails?.value, procedureAmount)
          .then((res) => {
            console.log(res,'[res]')
            if (res.message === 'success') {
              setProcedureAddRequestId(res.data);
              toast.success('Procedure added successfully');
              setProcedureNotCovered('');
              findRequestInformation(requestId);
              setProcedureAddRequestId(null);
            } else {
              toast.error(res.errorMessage, {autoClose: 5000});
              setProcedureNotCovered(res.errorMessage);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    };

    const handleApproveProcedure = (procedureRequestsId, procedureAmount, procedureId) => {
      const { requestId } = details;
      setLoading(true)
      console.log({ procedureRequestsId, procedureAmount, requestId, procedureId }, '[handleApproveProcedure][data]')
        deductWalletBalance(requestId, procedureAmount, procedureRequestsId, procedureId)
          .then((res) => {
            console.log(res,'[res.message]')
            if (res.message === 'success'|| res.message === 'Procedure Is not Covered in Policy') {
              setLoading(false)
              toast.success('Amount deducted successfully');
              setShowDialog(false);
              findRequestInformation(requestId);
              setProcedureAmount('');
              setProcedureDetails(null);
              setDeletePastProcedure(null);
              setDeletePastProcedureAmount('');
              setRemoveApproveButton(false);
              setProcedureAddRequestId(null);
            } else {
              toast.error(res.message);
              findRequestInformation(requestId);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }

    const deductAmountForProcedure = () => {
      const { requestId } = details;
      console.log({ procedureAddRequestId, procedureAmount, requestId}, '[procedureDetails][data]')
        deductWalletBalance(requestId, procedureAmount, procedureAddRequestId)
          .then((res) => {
            console.log(res,'[res.message]')
            if (res.message === 'success') {
              toast.success('Amount deducted successfully');
              setShowDialog(false);
              findRequestInformation(requestId);
              setProcedureAmount('');
              setProcedureDetails(null);
              setDeletePastProcedure(null);
              setDeletePastProcedureAmount('');
              setRemoveApproveButton(false);
              setProcedureAddRequestId(null);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }

    const handleRefundAmount = (requestId, requestProcedureId) => {
      console.log({ requestId, requestProcedureId }, '[handleRefundAmount]');
      setLoading(true)
      refundProcedureAmount(requestId, requestProcedureId)
        .then((response) => {
          console.log({response}, '[handleRefundAmount][refundProcedureAmount]');
          if (response.message === 'success') {
            setLoading(false)
            toast.success('Amount credited back successfully');
            setShowDialog(false);
            findRequestInformation(requestId);
            setProcedureAmount('');
            setProcedureDetails(null);
            setDeletePastProcedure(null);
            setDeletePastProcedureAmount('');
            setRemoveApproveButton(false);
            setProcedureAddRequestId(null);
          }
        }).catch((err) => {
          console.log({err}, '[handleRefundAmount][refundProcedureAmount]');
        })
    };

    const toggleConfirmationModal = () => {
      setShowConfirmationModal((prev) => !prev);
      setCallPatientLoading(false);
      setCallSpocLoading(false);
    };

    const getCallbackForTheConfirmation = () => {
      const { requestId } = basicInfo;
      console.log({ requestId }, '[patientPhone][getCallbackForTheConfirmation]');
      if (!requestId) {
        return;
      }
      setShowConfirmationModal(false);
      if (callTarget === 'SPOC') {
        const spocPhone = newCenterDetails?.spocPhone;
        return callCustomRequest(requestId, spocPhone, 'Health Center')
          .then((res) => {
            console.log(res, '[response]')
            toast.success('Called successfully');
          })
          .catch((err) => {
            console.error(err, '[callSpoc][error]')
            toast.error('Failed to call spoc');
          })
          .finally(() => setCallSpocLoading(false));
      }
      return callPatient(requestId)
        .then((res) => {
          console.log(res, '[response]')
          toast.success('Called successfully');
          findRequestInformation(requestId);
        })
        .catch((err) => {
          console.error(err, '[callPatient][error]')
          toast.error('Failed to call patient');
        })
        .finally(() => setCallPatientLoading(false));
    };
    const markProcedureDelete = (procedureId) => {
      const { requestId } = details;
      console.log('value',requestId,procedureId, procedureDetails?.value)
      markProcedureRemoved(requestId, procedureId ? procedureId : procedureDetails?.value)
      .then((response) => {
        console.log(response, '[response]');
        toast.success('Procedure Removed For Request')
        setShowDialog(false);
        findRequestInformation(requestId);
        setProcedureAmount('');
        setProcedureDetails(null);
        setDeletePastProcedure(null)
        setDeletePastProcedureAmount('')
        setRemoveApproveButton(false);
        setProcedureAddRequestId(null);
      })
      .catch((err) => {
        console.error(err, '[markProcedureRemoved][error]')
        toast.error('Failed to remove procedure');
      })

    }

    const transformInput = (inputValue, procedureList) => {
      if(!inputValue) {
        return true;
      }
      const options = {
        keys: ['label'], 
        threshold: 0.1,
      };
      const fuse = new Fuse([procedureList], options);

      const result = fuse.search(inputValue);
      
      console.log(result, '[transformInput]')
      if (result.length){
          return true;
      }
    };

    if (basicInfo && details.requestId) {
        console.log({procedureAmount, K:procedureDetails?.value, showProcedureDialog, procedureAddRequestId}, '[procedureDetails]')
        return (
          <>
          <Modal
            isOpen={details.showRequestDetails}
            toggle={onClose}
            size="lg"
            className="rtsp-modal-big"
          >
            <ModalHeader className="bg-primary" toggle={onClose}>
              {`Request Details (${details.requestId})`}
            </ModalHeader>
            <ModalBody>
              <Container fluid>
                <div className='row'>
                <ButtonGroup style={{ gap: '6px' }}>
                  <Button
                    onClick={() => setActiveInfo('basic')}
                    active={activeInfo === 'basic'}
                  >
                    Basic Info
                  </Button>
                  {newCenterDetails && <Button
                    onClick={() => setActiveInfo('center')}
                    active={activeInfo === 'center'}
                  >
                    Center Info
                  </Button>}
                  <Button
                    onClick={() => setActiveInfo('timeline')}
                    active={activeInfo === 'timeline'}
                  >
                    Appointment Timeline
                  </Button>
                  <Button
                    onClick={() => setActiveInfo('commslog')}
                    active={activeInfo === 'commslog'}
                  >
                    Comms Log
                  </Button>
                </ButtonGroup>
                </div>
                <div className="row">
                  <div className={`${activeInfo === 'commslog' ? 'col-md-12' : 'col-md-8'} overflow-hidden`}>
                    {activeInfo === 'basic' && renderBasicInfo()}
                    {activeInfo === 'center' && renderCenterInfo()}
                    {activeInfo === 'timeline' && <AppointmentTimeline  requestId={details.requestId} />}
                    {activeInfo === 'commslog' && <CommsLog requestId={details.requestId} />}
                  </div>
                  {activeInfo !== 'commslog' && (
                  <div className="col-md-4">
                        <CommentsPanel>
                          <CommentsPanelHeader>
                            {`Comments (${comments.length})`}
                          </CommentsPanelHeader>
                          <CommentsScrollArea>
                            <CommentList
                            loading={loading}
                            comments={comments}
                            />
                          </CommentsScrollArea>
                          <CommentsFade />
                          <CommentsComposer>
                            <CommentForm
                            addComment={(c)=> addComment([...comments, c])}
                            requestId={details.requestId}
                            type='dental'
                            />
                          </CommentsComposer>
                        </CommentsPanel>
                  </div>
                  )}
                  {activeInfo === 'basic' && (
                  <div className="col-12">
                    <div className="border-top">
                      {(opsUserId.includes(user) && !isMdpRequest) ?
                       <div className='flex flex-row'>
                        <Button
                          className="bg-primary"
                          style={{ padding: '10px', margin: '20px' }}
                          onClick={handleAddProcedureDetails}
                        >
                          + Add Procedure Details
                        </Button>
                        {procedureNotCovered && (
                          <div style={{color:'red', fontSize:'20px' }}>
                            {procedureNotCovered}
                          </div>
                        )}
                      </div> : ''}
                      <div>
                      {showDialog && !isMdpRequest && (
                          <DialogBox>
                            <div className="flex">
                              <div style={{ flex: '0.35' }}>
                              <FormGroup>
                                <Label
                                  className="text-black"
                                  for="procedureDetail"
                                >
                                  Procedure Details
                                </Label>
                                <Select 
                                  options={procedureList}
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  value={procedureDetails}
                                  cacheOptions={false}
                                  isClearable={true}
                                  isSearchable={true}
                                  filterOption={(option, rawInput)=>{
                                        return transformInput(rawInput, option);
                                  }}
                                  onChange={(selectedOption) => {
                                    console.log({selectedOption},'[selectedOption]')
                                    setProcedureDetails(selectedOption);
                                    setProcedureNotCovered('');
                                    setProcedureAmount('');
                                  }}
                                  styles={{
                                    option: (provided) => ({
                                      ...provided,
                                      color: 'black',
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      color: 'black',
                                    }),
                                  }}
                                   />
                              </FormGroup>
                              </div>
                              <div className='pl-2' style={{ flex: '0.35' }}>
                                <FormGroup>
                                  <Label className="text-black">
                                    Procedure Amount
                                  </Label>
                                  {console.log(procedureAmount,'[procedureAmount]')}
                                  <Input
                                    type="number"
                                    value={procedureAmount}
                                    placeholder="Input Field 2"
                                      onChange={(e) => {
                                      setProcedureAmount(e.target.value);
                                      }}
                                  />
                                </FormGroup>
                              </div>
                              <div className="flex" style={{ flex: '0.3', justifyContent: 'flex-end' }}>
                                {!removeApproveButton && <div style={{ marginRight: '0.5rem' }}>
                                  <Button className="bg-primary" style={{ width: '100%' }} onClick={()=>{addProcedureRequests()}} disabled = {!procedureAmount || !procedureDetails?.value}>
                                    Approve
                                  </Button>
                                </div>}
                                <div style={{ marginLeft: '0.5rem' }}>
                                  <Button className="bg-primary" onClick={handleCancel} style={{ width: '100%' }}>
                                      Cancel
                                  </Button>
                                  <div className='pt-2'>
                                  {/* {deletePastProcedure && deletePastProcedureAmount ? 
                                  <Button className='bg-danger' onClick={markProcedureDelete}>Delete Procedure</Button> 
                                   : ''} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {console.log(procedureAddRequestId, procedureAmount,procedureDetails?.value,'[procedureAddRequestId]')}
                            {/* <div style={{ width: '100%' }}>
                              <Button style={{ width: '100%' }} disabled={!procedureAmount || !procedureDetails?.value || !procedureAddRequestId} onClick={()=>{deductAmountForProcedure()}}>
                                Submit and deduct amount from user wallet
                              </Button>
                            </div> */}
                          </DialogBox>
                        
                          
                      )}

                      </div>
                      <div className='pt-2'>
                        {showProcedureDialog && (
                        <div className="flex border border-blue-500 flex-col p-2" style={{ backgroundColor: 'rgba(244, 241, 255)', borderRadius: '10px' }}>
                          <div className="flex justify-between">
                            <div>Available Primary Wallet amount Balance</div>
                            <div></div>
                            <div>₹{basicInfo.availablePrimaryWalletBalance ? (basicInfo.availablePrimaryWalletBalance) : 0}</div>
                          </div>
                          <div className="flex justify-between">
                            <div>Dental Wallet Balance before procedure</div>
                            <div></div>
                            <div>₹{basicInfo.previousAvailableWalletBalance ? (basicInfo.previousAvailableWalletBalance) : 0}</div>
                          </div>
                          <br/>
                          <table style={{ border: 'none' }}>
                            <thead>
                              <tr style={{ border: 'none' }}>
                                <th style={{ border: 'none' }}><strong>Detail</strong></th>
                                <th style={{ border: 'none' }}><strong>MRP</strong></th>
                                {showAgreedCost ? (
                                  <ApprovalHeaderCell><strong>{agreedCostHeading}</strong></ApprovalHeaderCell>
                                ) : null}
                                <th style={{ border: 'none' }}><strong>Wallet Coverage</strong></th>
                                <th style={{ border: 'none' }}><strong>Copay Amount</strong></th>
                                <ApprovalHeaderCell><strong>User Approval Status</strong></ApprovalHeaderCell>
                                <th style={{ border: 'none' }}><strong>Completed At</strong></th>
                                <th style={{ border: 'none' }}><strong>Action</strong></th>
                              </tr>
                            </thead>
                            <tbody>
                              {showProcedureDialog.map((procedure, index) => {
                                console.log({ procedure }, '[procedure]')
                                let cost = '', nameStyle = {}, walletDeduction = '';
                                if (procedure.success === -1) {
                                  cost = procedure.cost;
                                  nameStyle.color = 'red';
                                  walletDeduction = 'Insufficient balance';
                                } else if (procedure.success === -2) {
                                  cost = procedure.cost;
                                  nameStyle.color = 'red';
                                  walletDeduction = 'Not Covered In policy';
                                } else  {
                                  cost = procedure.cost;
                                  nameStyle.color = 'black';
                                  walletDeduction = procedure.walletDeduction === null ? 0 : parseFloat(procedure.walletDeduction).toFixed(0)
                                }
                                const copay = procedure.walletDeduction === null ? 0 : procedure.cost - procedure.walletDeduction  
                                return (
                                <tr key={index} style={{ border: 'none' }}>
                                  <td style={{ border: 'none', color: nameStyle.color }}>{procedure.procedureName} <span style={{ color: procedure.procedureRefundStatus ? 'red' : 'black' }}>{procedure.procedureRefundStatus ? '(Refunded)' : ''}</span></td>
                                  <td style={{ border: 'none', color: nameStyle.color }}>{cost}</td>
                                  {showAgreedCost ? (
                                    <AgreedCostCell>{renderAgreedCost(procedure)}</AgreedCostCell>
                                  ) : null}
                                  <td style={{ border: 'none', color: nameStyle.color }}>₹{walletDeduction}</td>
                                  <td style={{ border: 'none', color: nameStyle.color }}>₹{copay}</td>
                                  <ApprovalCell>
                                    <ApprovalStatusText tone={APPROVAL_STATUS_COLORS[procedure.approvalStatus]}>
                                      {procedure.approvalStatusLabel || '-'}
                                    </ApprovalStatusText>
                                    {procedure.approvalStatus === 'approved' && procedure.approvedAt ? (
                                      <ApprovalMetaText>{formatApprovedAt(procedure.approvedAt)}</ApprovalMetaText>
                                    ) : ''}
                                    {procedure.policyCoverage ? (
                                      <ApprovalMetaText tone={POLICY_COVERAGE_COLORS[procedure.policyCoverage]}>
                                        {POLICY_COVERAGE_SHORT[procedure.policyCoverage] || procedure.policyCoverageLabel}
                                      </ApprovalMetaText>
                                    ) : ''}
                                  </ApprovalCell>
                                  <ProcedureTableCell completed={!!procedure?.procedureCompletedAt}>{formatCompletedAt(procedure?.procedureCompletedAt)}</ProcedureTableCell>
                                  <td style={{ border: 'none', color: nameStyle.color, display: 'flex' }}>{!procedure.procedureRefundStatus && procedure.success === null ? <Button onClick={()=> markProcedureDelete(procedure.procedureRequestsId)}>Delete</Button> : ''} 
                                  {procedure.walletDeduction === null && procedure.success === null ? (
                                    <Button style={{ marginLeft: '1px' }} onClick={() => handleApproveProcedure(procedure.procedureRequestsId, procedure.cost, procedure.procedureId)} disabled={loading}>
                                      Approve
                                    </Button>
                                  ) : ''}
                                   {(procedure.walletDeduction !== null && procedure.success === 1 && !procedure.procedureRefundStatus) && opsUserId.includes(user) ? ( <Button style={{ marginLeft: '1px' }} onClick={()=> handleRefundAmount(procedure.requestId, procedure.procedureRequestsId)} disabled={loading}>Refund</Button>):''}
                                  </td>
                                </tr>
                              )})}
                            </tbody>
                          </table>
                          <div className="border-top flex justify-between">
                            <div>Current Dental Wallet Balance</div>
                            <div style={{ color: 'rgba(113, 79, 255)' }} className="font-bold">
                              ₹{policyDetails && policyDetails.availableSubWalletBalance ? parseFloat(policyDetails.availableSubWalletBalance) : 0}
                            </div>
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                  )}
                </div>
              </Container>
            </ModalBody>
          </Modal>
          <ConfirmationModal
            confirmationMessage={confirmationMessage}
            isOpen={showConfirmationModal}
            toggle={() => toggleConfirmationModal()}
            callback={() => getCallbackForTheConfirmation()}
          />
          {showEditDateModal && (
            <UpdateAppointmentDateModal
              isOpen={showEditDateModal}
              closeModal={() => setShowEditDateModal(false)}
              requestId={details.requestId}
              currentDate={basicInfo.appointmentDate}
              onSuccess={() => findRequestInformation(details.requestId)}
            />
          )}
          </>
        );
    } else {
        return <div />
    }
}

export default DentalRequestDetails;